import { render } from "./EditCreate.vue?vue&type=template&id=a5875560&ts=true"
import script from "./EditCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditCreate.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/Plots/EditCreate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5875560"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5875560', __exports__)) {
    console.log('reload')
    api.reload('a5875560', __exports__)
  }
  
  module.hot.accept("./EditCreate.vue?vue&type=template&id=a5875560&ts=true", () => {
    console.log('re-render')
    api.rerender('a5875560', render)
  })

}


export default __exports__